import React, { useEffect, useState } from 'react';
import HistoryInterviewTable from './InterviewsTableComponent/HistoryInterviewTable';
import { useAppDispatch, useAppSelector } from '../../useStore';
import { getallapplicant, reset } from "../../features/Applicant/applicantSlice";
import swal from "sweetalert";




const InterviewHistory = () => {
  const [resetID, setResetID] = useState(false)
  const dispatch = useAppDispatch();
  const {
    EvalvationisSuccess,
    UpdateScreeningStatusisSuccess,
    sendOfferisSuccess,
    applicationInterviewisSuccess,
    updateApplicationInterviewStatusisSuccess,
    sendEmailisSuccess,
    shareApplicationisSuccess,
    ScreeningisSuccess,
    applicationassignedisSuccess,
    scheduleApplicantisSuccess,
    updateInterviewStatusisSuccess,
    UpdateOfferisSuccess,
    sendForHireisSuccess,
    EditapplicantionisSuccess,
    sendForTranningisSuccess,
    updateTranningisSuccess,
    data,
    isError,
    isLoading,
    message,
  } = useAppSelector((state: { applicant: any }) => state.applicant);

  useEffect(() => {
    const input = { applicationStatus: "APPLIED" };
    if (
      EvalvationisSuccess ||
      UpdateScreeningStatusisSuccess ||
      sendOfferisSuccess ||
      applicationInterviewisSuccess ||
      updateApplicationInterviewStatusisSuccess ||
      sendEmailisSuccess ||
      shareApplicationisSuccess ||
      ScreeningisSuccess ||
      applicationassignedisSuccess ||
      scheduleApplicantisSuccess ||
      updateInterviewStatusisSuccess ||
      UpdateOfferisSuccess ||
      sendForTranningisSuccess ||
      sendForHireisSuccess || EditapplicantionisSuccess || updateTranningisSuccess || resetID
    ) {
      // @ts-ignore 
      dispatch(getallapplicant(input))

      setTimeout(() => {
        dispatch(reset());
      }, 2000);
    }
  }, [resetID, UpdateOfferisSuccess, EvalvationisSuccess, UpdateScreeningStatusisSuccess, sendOfferisSuccess, applicationInterviewisSuccess, updateApplicationInterviewStatusisSuccess, sendEmailisSuccess, shareApplicationisSuccess, ScreeningisSuccess, applicationassignedisSuccess, scheduleApplicantisSuccess, updateInterviewStatusisSuccess, sendForHireisSuccess, EditapplicantionisSuccess, dispatch, sendForTranningisSuccess, updateTranningisSuccess]);



  useEffect(() => {
    const input = { applicationStatus: "APPLIED" };
    // @ts-ignore 
    dispatch(getallapplicant(input))

  }, [ScreeningisSuccess, dispatch]);
  
  useEffect(() => {
    if (isError) {
      swal({
        title: "error",
        text: message,
        icon: "error"
      })
      dispatch(reset())
    }
  }, [dispatch, isError, message])
  return (
    <div>
      <HistoryInterviewTable
        pageHeader={"Interview / History"}
        setResetID={setResetID}
        data={data}
        isLoading={isLoading}
        message={message}
        isError={isError}
        headerTitles={[
          "",
          "Edit",
          "Application Status",
          "Update",
          "Applicant Name",
          "Gender",
          "Date Of Birth",
          "Job Profile",
          "View ID",
          "Applied on",
          "Last Updated on",
          "Email",
          "Phone Number",
          "Work Experience",
          "Relevant Work Experience",
          "Edit"
        ]} />
    </div>
  )
}

export default InterviewHistory
